/* global appData */

// Template and media files
import template from './type-market.vhtml';

export default {
	template: template,
	data: () => ({
		isFullWidth: !appData.appSettings.activate_share,
	}),
	computed: {
		selectedOptions: vm => vm.$store.getters['personalization/getSelectedOptions'],
	},
	methods: {
		navigateRight(to) {
			this.$store.commit('pages/updateData', {
				name: 'isNavigating',
				value: true,
			});
			this.$store.commit('pages/updateData', {
				name: 'transition',
				value: 'slide-right',
			});
			this.$store.commit('pagination/updateData', {
				name: 'showNav',
				value: false,
			});
			this.$nextTick(function () {
				this.$router.push({ path: to, query: this.$route.query });
			});
			// this.$store.commit('personalization/updateFirstSelection', {
			// 	label: '',
			// });
		},
	},
};


// WEBPACK FOOTER //
// ./assets/_js/components/type-market/type-market.js